export const LEVELUP_ACTIONS = {
  OPEN_ROLE_SELECTION_MODAL: 'OPEN_ROLE_SELECTION_MODAL',
  CLOSE_ROLE_SELECTION_MODAL: 'CLOSE_ROLE_SELECTION_MODAL',
  SET_LEVEL_UP_DETAILS: 'SET_LEVEL_UP_DETAILS',
  SET_IS_MANAGER_FLAG: 'SET_IS_MANAGER_FLAG',
  UPDATE_COMPETENCY_TARGET_DATE: 'UPDATE_COMPETENCY_TARGET_DATE',
  UPDATE_COMPETENCY_PROGRESS_STATUS: 'UPDATE_COMPETENCY_PROGRESS_STATUS',
  SET_ONE_ON_ONE_INSTANCE_DETAILS: 'SET_ONE_ON_ONE_INSTANCE_DETAILS',
  CHANGE_SELECTED_ROLE: 'CHANGE_SELECTED_ROLE',
  SET_LEVEL_UP_TARGET_DATES: 'SET_LEVEL_UP_TARGET_DATES',
  TOGGLE_COMPETENCY_FILTER: 'TOGGLE_COMPETENCY_FILTER',
  SET_FILTERED_COMPETENCY_TABLE_DATA: 'SET_FILTERED_COMPETENCY_TABLE_DATA',
  SET_LEVEL_UP_PROGRESS_STATUSES: 'SET_LEVEL_UP_PROGRESS_STATUSES',
  SET_FUNCTION_AND_ROLE_NOT_SET: 'SET_FUNCTION_AND_ROLE_NOT_SET',
  SET_LEVEL_UP_RISK_ESTIMATION_LIST: 'SET_LEVEL_UP_RISK_ESTIMATION_LIST',
  SET_ALL_COMPETENCY_FILTER: 'SET_ALL_COMPETENCY_FILTER',
};
